"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _profile = require("@widget/profile");

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _utils = require("@package/utils");

var _dialog = require("@package/dialog");

var _table = require("@package/table");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _RefundDialog = _interopRequireDefault(require("./RefundDialog"));

var _Shop = _interopRequireDefault(require("./Shop"));

var _Dates = _interopRequireDefault(require("./Dates"));

var _OrderId = _interopRequireDefault(require("./OrderId"));

var _Amount = _interopRequireDefault(require("./Amount"));

var _StatusInfo = _interopRequireDefault(require("./StatusInfo"));

var _Description = _interopRequireDefault(require("./Description"));

var _ApplyProcess = _interopRequireDefault(require("./ApplyProcess"));

var _CancelProcess = _interopRequireDefault(require("./CancelProcess"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var INVOICE_HELD_STATUS_CODE = 10;
var SHOP_STATUS_ACTIVE = 1;

function checkRefundPermission(value, permissions) {
  var _value$status, _value$shop$status;

  var hasCreateRefund = (0, _utils.checkPermission)(permissions, 'operation.invoice.refund');
  var statusCode = [3, 6].indexOf((_value$status = value['status']) === null || _value$status === void 0 ? void 0 : _value$status['code']) > -1;
  return !!(hasCreateRefund && statusCode && (value === null || value === void 0 ? void 0 : (_value$shop$status = value['shop']['status']) === null || _value$shop$status === void 0 ? void 0 : _value$shop$status['code']) === SHOP_STATUS_ACTIVE);
}

function checkApplyPermission(value, permissions) {
  var _value$status2;

  var hasInvoiceApplyPermissions = (0, _utils.checkPermission)(permissions, 'operation.invoice.auth');
  var statusCode = [INVOICE_HELD_STATUS_CODE].indexOf(value === null || value === void 0 ? void 0 : (_value$status2 = value['status']) === null || _value$status2 === void 0 ? void 0 : _value$status2['code']) > -1;
  return !!(hasInvoiceApplyPermissions && statusCode);
}

function checkCancelPermission(value, permissions) {
  var _value$status3;

  var hasInvoiceCancelPermissions = (0, _utils.checkPermission)(permissions, 'operation.invoice.cancel');
  var statusCode = [INVOICE_HELD_STATUS_CODE].indexOf(value === null || value === void 0 ? void 0 : (_value$status3 = value['status']) === null || _value$status3 === void 0 ? void 0 : _value$status3['code']) > -1 && value['status']['code'] !== 8;
  return !!(hasInvoiceCancelPermissions && statusCode);
}

function TableComponent() {
  try {
    var handleResetFilter = function handleResetFilter() {
      navigate(process.env['PUBLIC_URL'] + '/operations/invoices');
    };

    var handleExport = function handleExport() {
      var query = (0, _utils.queryToObject)(location['search']);
      dispatch((0, _invoices.exportInvoices)((0, _objectSpread2["default"])({
        order: 'created',
        dateFrom: (0, _moment["default"])().subtract(1, 'months').format('YYYY-MM-DD 00:00:00.000000+03:00'),
        dateTo: (0, _moment["default"])().format('YYYY-MM-DD 23:59:59.999999+03:00'),
        status: -1,
        amountFrom: null,
        amountTo: null,
        searchTerm: null,
        shopDemoMode: query['shopDemoMode'] || false
      }, query)));
    };

    var handleCreateRefund = function handleCreateRefund(data) {
      dispatch((0, _invoices.createRefund)({
        id: data['id'],
        amount: data['amount'],
        reason: data['reason'],
        masterId: data['masterId'],
        externalId: data['externalId'],
        finalAmount: data['finalAmount']
      }));
    };

    var handleGetDetails = function handleGetDetails(value) {
      navigate(process.env['PUBLIC_URL'] + '/operations/invoices/' + value);
    };

    var handleRefund = function handleRefund(invoice) {
      dispatch((0, _dialog.openDialog)('create-refund', {
        id: invoice['id'],
        amount: invoice['amount'] !== invoice['finalAmount'] ? invoice['finalAmount'] : invoice['amount'],
        masterId: invoice['masterId'],
        currency: invoice['currency'],
        externalId: invoice['externalId'],
        finalAmount: invoice['finalAmount'],
        reason: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u043F\u043E \u0441\u0447\u0435\u0442\u0443 (\u043D\u043E\u043C\u0435\u0440 \u0437\u0430\u043A\u0430\u0437\u0430: ".concat(invoice['externalId'], ")")
      }));
    };

    var handleApply = function handleApply(value) {
      dispatch((0, _dialog.openDialog)("invoice-apply", value));
    };

    var handleCancel = function handleCancel(value) {
      dispatch((0, _dialog.openDialog)("invoice-cancel", value));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var items = (0, _reactRedux.useSelector)(_invoices.selectItems);
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var meta = (0, _reactRedux.useSelector)(_invoices.selectMeta);
    var inExportProcess = (0, _reactRedux.useSelector)(_invoices.selectInExportProcess);
    var query = (0, _utils.queryToObject)(location['search']);
    var queryData = {
      dateFrom: query['dateFrom'] ? (0, _moment["default"])(query['dateFrom']).format('DD.MM.YYYY') : (0, _moment["default"])().subtract(1, 'months').format('DD.MM.YYYY'),
      dateTo: (0, _moment["default"])(query['dateTo'] || new Date()).format('DD.MM.YYYY')
    };
    var totalRow = (0, _numeral["default"])(meta['totalRow']).format('0,00');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "invoices.header",
      className: _defaultModule["default"]['message']
    }, totalRow === '0' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u041D\u0435\u0442 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u041D\u0430\u0439\u0434\u0435\u043D\u043E ", totalRow, " ", (0, _utils.nounDeclension)(meta['totalRow'], ['операция', 'операции', 'операций'])), " \u0441 ", queryData['dateFrom'], " \u043F\u043E ", queryData['dateTo']), /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "invoices.reset-filter",
      className: _defaultModule["default"]['link'],
      onClick: function onClick() {
        return handleResetFilter();
      }
    }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B"), totalRow !== '0' && /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Icon, {
      "data-locator": "invoices.export_button",
      icon: 'icon-csv',
      inProcess: inExportProcess,
      onClick: function onClick() {
        return handleExport();
      }
    }))), !!items.length && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['table']
    }, /*#__PURE__*/_react["default"].createElement(_table.Table, {
      _data: "invoices",
      empty: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
      columns: items
    }, /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "creation-date",
      title: "\u0414\u0430\u0442\u0430",
      width: "140",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Dates["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "external-id",
      title: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u043A\u0430\u0437\u0430",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_OrderId["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "shop",
      title: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
      alias: "shop",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Shop["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "description",
      title: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u043A\u0430\u0437\u0430",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Description["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "amount",
      title: "\u0421\u0443\u043C\u043C\u0430",
      width: "160",
      align: "right"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Amount["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "status",
      title: "\u0421\u0442\u0430\u0442\u0443\u0441",
      width: "140",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_StatusInfo["default"], Object.assign({
        "data-locator": 'invoice.status'
      }, value));
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      width: 60
    }, function (value) {
      var _profile$user, _profile$user2, _profile$user3;

      return /*#__PURE__*/_react["default"].createElement(_storybook.Settings, {
        _data: 'invoices',
        items: [checkRefundPermission(value, profile === null || profile === void 0 ? void 0 : (_profile$user = profile['user']) === null || _profile$user === void 0 ? void 0 : _profile$user['permissions']) && {
          title: 'Возврат',
          onClick: function onClick() {
            return handleRefund(value);
          },
          '_data': 'invoice-refund'
        }, checkApplyPermission(value, profile === null || profile === void 0 ? void 0 : (_profile$user2 = profile['user']) === null || _profile$user2 === void 0 ? void 0 : _profile$user2['permissions']) && {
          title: 'Подтвердить',
          onClick: function onClick() {
            return handleApply(value);
          },
          '_data': 'invoice-apply'
        }, checkCancelPermission(value, profile === null || profile === void 0 ? void 0 : (_profile$user3 = profile['user']) === null || _profile$user3 === void 0 ? void 0 : _profile$user3['permissions']) && {
          title: 'Отмена',
          onClick: function onClick() {
            return handleCancel(value);
          },
          '_data': 'invoice-cancel'
        }, {
          title: 'Информация',
          onClick: function onClick() {
            return (value === null || value === void 0 ? void 0 : value['uuid']) && handleGetDetails(value['uuid']);
          },
          '_data': 'invoice-info'
        }]
      });
    }))), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      title: 'Возврат денежных средств',
      name: "create-refund"
    }, /*#__PURE__*/_react["default"].createElement(_RefundDialog["default"], {
      onSubmit: function onSubmit(data) {
        return handleCreateRefund(data);
      }
    })), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      title: "",
      name: 'invoice-apply'
    }, /*#__PURE__*/_react["default"].createElement(_ApplyProcess["default"], {
      "data-locator": 'invoice'
    })), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      title: '',
      name: 'invoice-cancel'
    }, /*#__PURE__*/_react["default"].createElement(_CancelProcess["default"], {
      "data-locator": 'invoice'
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = TableComponent;
exports["default"] = _default;